
define('text!views/terms/term_links.html',[],function () { return '\r\n<div class="profile-terms-container">\r\n\r\n\t<h2>Terms and Agreements</h2>\r\n\t\r\n\t<ul class="profile-terms-list js-terms-list"></ul>\r\n\r\n</div>';});

